import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { TextField } from "../../../../../../features/forms/fields/text-field/text-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlSalesForecast = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <TextField
      form={props.form}
      label="Sales Forecast"
      name="targetSalesForecast"
      numeric
      userPermissions={props.userPermissions}
    />
  </BorderedBlock>
);
